import React from 'react';

const SocialAuthCss = () => (
  <div>
    <style jsx global>{`
      .social-button {
        color: white;
        font-size: 14px;
        text-align: start;
        background: #333;
        margin-bottom: 14px;
        display: flex;
        align-items: center;
        border-radius: 8px;
        overflow: hidden;

        transition: all 100ms ease-out;
      }

      .social-button:hover {
        filter: brightness(95%);
      }

      .social-button:active {
        filter: brightness(95%);
      }

      .social-button .social-button-icon {
        width: 46px;
        height: 46px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: 18px 18px;
        display: inline-block;
        vertical-align: middle;
        flex-grow: 0;
      }

      .social-button .social-button-icon.github-icon {
        background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOSAxOCI+PHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTkuNSAwQTkuMzcgOS4zNyAwIDAgMCAwIDkuMjNhOS4yNiA5LjI2IDAgMCAwIDYuNSA4Ljc1Yy40Ny4wOS42NS0uMi42NS0uNDRsLS4wMi0xLjcyYy0yLjY0LjU2LTMuMi0xLjA5LTMuMi0xLjA5LS40My0xLjA2LTEuMDUtMS4zNS0xLjA1LTEuMzUtLjg3LS41Ny4wNi0uNTYuMDYtLjU2Ljk2LjA3IDEuNDYuOTUgMS40Ni45NS44NSAxLjQxIDIuMjIgMSAyLjc2Ljc3LjA5LS42LjM0LTEgLjYtMS4yMy0yLjEtLjI0LTQuMzItMS4wMy00LjMyLTQuNTYgMC0xLjAxLjM3LTEuODMuOTgtMi40OC0uMS0uMjMtLjQzLTEuMTcuMDktMi40NCAwIDAgLjgtLjI1IDIuNjEuOTRhOS4zIDkuMyAwIDAgMSA0Ljc2IDBjMS44MS0xLjIgMi42LS45NCAyLjYtLjk0LjUzIDEuMjcuMiAyLjIuMSAyLjQ0LjYxLjY1Ljk4IDEuNDcuOTggMi40OCAwIDMuNTQtMi4yMiA0LjMyLTQuMzQgNC41NS4zNC4yOS42NS44NS42NSAxLjdsLS4wMiAyLjU0YzAgLjI1LjE4LjUzLjY2LjQ0QTkuMjYgOS4yNiAwIDAgMCAxOSA5LjIzQzE5IDQuMTMgMTQuNzUgMCA5LjUgMHoiLz48L3N2Zz4=);
      }

      .social-button .social-button-icon.google-icon {
        background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOCAxOCI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBmaWxsPSIjNDI4NUY0IiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0xNy42NCA5LjJjMC0uNjMtLjA2LTEuMjUtLjE2LTEuODRIOXYzLjQ5aDQuODRhNC4xNCA0LjE0IDAgMCAxLTEuOCAyLjcxdjIuMjZoMi45MmE4Ljc4IDguNzggMCAwIDAgMi42OC02LjYyeiIvPjxwYXRoIGZpbGw9IiMzNEE4NTMiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTkgMThhOC42IDguNiAwIDAgMCA1Ljk2LTIuMThsLTIuOTEtMi4yNmE1LjQgNS40IDAgMCAxLTguMDktMi44NWgtM3YyLjMzQTkgOSAwIDAgMCA5IDE4eiIvPjxwYXRoIGZpbGw9IiNGQkJDMDUiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTMuOTYgMTAuNzFhNS40MSA1LjQxIDAgMCAxIDAtMy40MlY0Ljk2aC0zYTkgOSAwIDAgMCAwIDguMDhsMy0yLjMzeiIvPjxwYXRoIGZpbGw9IiNFQTQzMzUiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTkgMy41OGMxLjMyIDAgMi41LjQ1IDMuNDQgMS4zNWwyLjU4LTIuNTlBOSA5IDAgMCAwIC45NiA0Ljk1bDMgMi4zNEE1LjM2IDUuMzYgMCAwIDEgOSAzLjU4eiIvPjxwb2x5Z29uIHBvaW50cz0iMCAwIDE4IDAgMTggMTggMCAxOCIvPjwvZz48L3N2Zz4=);
      }

      .social-button .social-button-icon.linkedin-icon {
        background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNNC45OCAzLjVjMCAxLjM4MS0xLjExIDIuNS0yLjQ4IDIuNXMtMi40OC0xLjExOS0yLjQ4LTIuNWMwLTEuMzggMS4xMS0yLjUgMi40OC0yLjVzMi40OCAxLjEyIDIuNDggMi41em0uMDIgNC41aC01djE2aDV2LTE2em03Ljk4MiAwaC00Ljk2OHYxNmg0Ljk2OXYtOC4zOTljMC00LjY3IDYuMDI5LTUuMDUyIDYuMDI5IDB2OC4zOTloNC45ODh2LTEwLjEzMWMwLTcuODgtOC45MjItNy41OTMtMTEuMDE4LTMuNzE0di0yLjE1NXoiLz48L3N2Zz4=);
      }

      .social-button .social-button-text {
        letter-spacing: 0.5px;
        font-weight: bold;
        line-height: 46px;
        height: 46px;
        padding-inline-start: 12px;
        position: relative;
        flex-grow: 2;
      }

      .social-button.google-button {
        padding-inline-start: 4px;
        background: #f5f5f5;
      }

      .social-button.google-button .social-button-text {
        color: #404040;
        background-color: #f5f5f5;
      }

      .social-button.github-button {
        background: #222;
      }

      .social-button.github-button .social-button-text {
        background-color: #333;
      }

      .social-button.saml-button {
        background: #3c2697;
      }

      .social-button.saml-button .social-button-text {
        color: white;
        background-color: #111166;
      }

      .social-button.linkedin-button {
        padding-inline-start: 4px;
        background: #f5f5f5;
      }

      .social-button.linkedin-button .social-button-text {
        color: #404040;
        background-color: #f5f5f5;
      }
    `}</style>
  </div>
);

export default SocialAuthCss;
